var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP 기기등록현황 - List 개발
 *
 ********************************************************************/
import React, { useState, useEffect, useCallback, useRef } from "react";
//
import axios from 'axios';
import { useAsync } from "react-async";
// recoli & state
import { useRecoilValue, useRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { loadingBoxState, urlState } from "../../../recoil/menuState";
//utils
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import * as FILEUTIL from "../../../utils/file/fileUtil";
import clog from "../../../utils/logUtils";
//압축 다운로드
import JSZip from "jszip";
import * as XLSX from 'xlsx';
import * as FileSaver from "file-saver";
import { useNavigate } from "react-router-dom";
import EhpPagination from "../../common/pagination/EhpPagination";
import { useTrans } from "../../../utils/langs/useTrans";
/**
* @brief EHP 기기등록현황 개발 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
function DeciveStatusView(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [urlInfo, setRecoilUrlInfo] = useRecoilState(urlState);
    //화면 이동
    const navigate = useNavigate();
    // props
    const setParentPopWin = props.setPopWin;
    const curTab = props.curTab;
    const pageInfo = props.pageInfo;
    const setPageInfo = props.setPageInfo;
    const isMobile = props.isMobile;
    const setParentIsMobile = props.setIsMobile;
    const nodata = props.nodata;
    const setNodata = props.setNodata;
    const handleCurPage = props.handleCurPage;
    const subZoneId = props.subZoneId;
    const setSubZoneId = props.setSubZoneId;
    const roomId = props.roomId;
    const setRoomId = props.setRoomId;
    const spgList = props.spgList;
    const setSpgList = props.setSpgList;
    const searchText = props.searchText;
    const setSearchText = props.setSearchText;
    const searchData = props.searchData;
    const setSearchData = props.setSearchData;
    const searchFieldList = [
        //{"id":0, "sfDisp":"전체", "sfVal":""},
        { "id": 1, "sfDisp": t("FIELD.모델명"), "sfVal": "modelName" },
        { "id": 2, "sfDisp": t("FIELD.Panel명"), "sfVal": "panelName" },
        { "id": 3, "sfDisp": t("FIELD.시리얼번호"), "sfVal": "serialNo" },
    ];
    const [searchField, setSearchField] = useState(searchFieldList[0]);
    //
    const [errorList, setErrorList] = useState([]);
    const [subZoneItem, setSubZoneItem] = useState([]);
    const [roomItem, setRoomItem] = useState([]);
    const [spgItem, setSpgItem] = useState([]);
    const [countItem, setCountItem] = useState(null);
    const [listItem, setListItem] = useState([]);
    const [curSubZone, setCurSubZone] = useState(""); // 
    const [CurRoom, setCurRoom] = useState(""); // 
    const [curSpg, setCurSpg] = useState(""); // 
    //검색
    const [listReload, setListReload] = useState(false);
    const [sortData, setSortData] = useState({ "sortField": "spgName", "sort": "ASC" });
    const [checkItem, setCheckItem] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [item, setItem] = useState(null);
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (mobileRef.current) {
            if ((mobileRef.current.clientHeight <= 0) && (mobileRef.current.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }), 100, [listItem]);
    var zoneId = curTab.zoneId;
    let appPath = zoneId;
    //세부사업장API
    const { data: sub, } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath
    });
    const { data: spg, } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: "/api/v2/product/company/zone/subzone/room/spgs",
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        // tab API
        if (sub) {
            // error page 이동
            if (sub.codeNum == CONST.API_200) {
                setSubZoneItem(sub.body);
            }
            else {
                alert(sub.errorList.map((err) => (err.msg)));
            }
        }
        if (spg) {
            if (spg.codeNum == CONST.API_200) {
                setSpgItem(spg.body);
            }
            else {
                alert(spg.errorList.map((err) => (err.msg)));
            }
        }
    }, [sub, spg]);
    // device count API
    appPath = "zoneId=" + appPath;
    // subZone {t("LABEL.검색")}
    if (!CUTIL.isnull(subZoneId) && (subZoneId.length > 0)) {
        appPath = appPath + "&subZoneId=" + subZoneId;
    }
    //
    if (!CUTIL.isnull(roomId) && (roomId.length > 0)) {
        appPath = appPath + "&roomId=" + roomId;
    }
    if (!CUTIL.isnull(spgList) && (spgList.length > 0)) {
        appPath = appPath + "&spgList=" + spgList;
    }
    const { data: count } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/panel/item/devicelistcount?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath
    });
    useEffect(() => {
        // tab API
        if (count) {
            // error page 이동
            if (count.codeNum == CONST.API_200) {
                setCountItem(count.body);
            }
            else {
                alert(count.errorList.map((err) => (err.msg)));
            }
        }
    }, [count]);
    // device List API
    appPath = appPath + '&page=' + pageInfo.number + '&size=' + pageInfo.size;
    // sort
    appPath = appPath + '&sort=' + sortData.sortField + ',' + sortData.sort;
    // {t("LABEL.검색")} 
    //text검색
    if (searchData.searchField) {
        if (searchData.searchField.sfVal.length > 0) {
            appPath = appPath + `&searchKind=${searchData.searchField.sfVal}&stringLike=${searchData.searchText}`;
        }
    }
    const { data: data, isLoading } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        //deferFn: HttpUtil.Http,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/panel/item/devicelist?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + listReload
    });
    useEffect(() => {
        // tab API
        if (data) {
            // error page 이동
            const ERR_URL = HttpUtil.resultCheck(isLoading, data);
            if (ERR_URL.length > 0)
                navigate(ERR_URL);
            if (data.codeNum == CONST.API_200) {
                setListItem(data.body);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: (isMobile) ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, "listReload": false })); //5, 10; //5, 10
            }
            else {
                alert(data.errorList.map((err) => (err.msg)));
            }
        }
    }, [data]);
    // subZone선택 및 room  API 초기화
    function selectSubZone(subZoneId) {
        return __awaiter(this, void 0, void 0, function* () {
            setCurSubZone(subZoneId);
            if (CurRoom) {
                var roomsel = document.getElementById("room");
                var roomReset = document.getElementById("room_all");
                var roomselM = document.getElementById("mroom");
                var roomResetM = document.getElementById("mroom_all");
                roomselM.click();
                roomResetM.click();
                roomsel.click();
                roomReset.click();
                setRoomItem([]);
                setRoomId("");
            }
            else {
                let data = null;
                data = yield HttpUtil.PromiseHttp({
                    "httpMethod": "GET",
                    "appPath": `/api/v2/product/company/zone/subzone/${subZoneId}`,
                    userToken: userInfo.loginInfo.token,
                });
                if (data.codeNum == 200) {
                    setRoomItem(data.body);
                }
                else {
                }
            }
        });
    }
    //fliter 조회
    function searchDevice(e) {
        setSubZoneId(curSubZone);
        setRoomId(CurRoom);
        setSpgList(curSpg);
        handleCurPage(0);
    }
    // Fliterpop
    useEffect(() => {
        setParentPopWin("pop-filter", React.createElement(MobileFilterPopup, { subZoneItem: subZoneItem, roomItem: roomItem, spgItem: spgItem, selectSubZone: selectSubZone, curSubZone: curSubZone, setCurSubZone: setCurSubZone, CurRoom: CurRoom, setCurRoom: setCurRoom, curSpg: curSpg, setCurSpg: setCurSpg, searchDevice: searchDevice }));
    });
    function testViewPop(e, item) {
        setItem(item);
        (() => __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            const resp = yield HttpUtil.API_reportView(item.serialNo);
            setReportList(resp);
            setRecoilIsLoadingBox(false);
            CUTIL.jsopen_Popup(e);
        }))();
    }
    useEffect(() => {
        setParentPopWin("pop-downtest", React.createElement(PopupReportView, { htmlHeader: (item) && React.createElement("h1", null, item.modelName + "_검사 성적서"), item: item, reportInfo: reportList }));
        setNodata(pageInfo.totalElements);
    });
    function PopClose(id) {
        var btnCommentClose = document.getElementById(id);
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "itmeTxt: none; z-index: 11; ");
    }
    // change pop
    useEffect(() => {
        setParentPopWin("pop-change", React.createElement(ChanagePop, { htmlHeaderBtn: React.createElement("button", { className: "btn btn-close js-close", onClick: (e) => PopClose("pop-change") },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), setRecoilIsLoadingBox: setRecoilIsLoadingBox, checkItem: checkItem, setCheckItem: setCheckItem }));
    });
    // mobile search pop
    useEffect(() => {
        setParentPopWin("pop-search-small", React.createElement(MobilePopupSearch, { searchFieldList: searchFieldList, setSearchField: setSearchField, searchText: searchText, setSearchText: setSearchText, goSearch: goSearch }));
    }); //re-rendering을 모바일 화면까지 전달하기 위해...
    function onClickSearch(e) {
        // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
        var schDiv = document.querySelector("#mcheck_searchinput");
        clog("MOBILE CHECK : TEXT SEARCH : " + schDiv.clientHeight + " X " + schDiv.clientWidth);
        var isSchMobile = (schDiv.clientHeight <= 0) && (schDiv.clientWidth <= 0) ? true : false;
        (isSchMobile) && setParentPopWin("pop-search-small", React.createElement(MobilePopupSearch, { searchFieldList: searchFieldList, setSearchField: setSearchField, searchText: searchText, setSearchText: setSearchText, goSearch: goSearch }));
        (isSchMobile) && CUTIL.jsopen_m3_Popup(e, isSchMobile);
        (!isSchMobile) && goSearch(e);
        handleCurPage(0);
    }
    // table search 
    function goSearch(e) {
        //clog("goSearch : " + JSON.stringify(searchField));
        handleCurPage(0);
        setSearchData({
            "searchField": searchField,
            "searchText": searchText,
        });
    }
    // sort 
    function onClickSort(selSortField) {
        var selSort = (sortData.sort === "ASC") ? "DESC" : "ASC";
        if (selSortField !== sortData.sortField) { // 정렬필드가 변경된 경우
            selSort = "DESC";
        }
        setSortData({
            "sortField": selSortField,
            "sort": selSort
        });
        handleCurPage(0);
    }
    //chcek All
    const checkedAll = useCallback((checked) => {
        if (checked) {
            const checkedArray = [];
            listItem.forEach((list) => { checkedArray.push(list); });
            setCheckItem(checkedArray);
        }
        else {
            setCheckItem([]);
        }
    }, [listItem]);
    // check singe
    const checkedList = useCallback((checked, list) => {
        if (checked) {
            setCheckItem([...checkItem, list]);
        }
        else {
            setCheckItem(checkItem.filter((el) => el !== list));
        }
    }, [checkItem]);
    // 엑셀 API
    function exeelList(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/product/company/zone/subzone/room/panel/item/excellist?zoneId=${curTab.zoneId}`,
                /*     "appQuery": {
                       "zoneId ": curTab.zoneId,
                   },  */
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    excelDownloadSaved(data.body);
                }
                else {
                    alert(data.errorList.map((err) => (err.msg)));
                }
            }
        });
    }
    // List Download 
    function excelDownloadSaved(excelData) {
        const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'; // 파일 타입 및 유니코드
        // const book = XLSX.utils.book_new();
        const excelFileExtension = '.xlsx'; // 확장자 명
        const excelFileName = curTab.company.companyName + "_" + curTab.zoneName + "_eHC_" + "DeviceList"; // 파일명
        const excelSheet = XLSX.utils.aoa_to_sheet([
            [
                'no', '기기유형', 'Panel명', "정격전압(kV)", "2차전압(kV)", "정격전류(A)", "차단전류(kA)", "정격용량(kVA)", "모델명", "시리얼번호", "제조사", "메모",
                "점검일자", "B전체점수", "P전체점수", "A전체점수", "B01이름", "B01선택", "B01점수", "B02이름", "B02선택", "B02점수", "B03이름", "B03선택", "B03점수",
                "B04이름", "B04선택", "B04점수", "B05이름", "B05선택", "B05점수", "B06이름", "B06선택", "B06점수", "B07이름", "B07선택", "B07점수", "B08이름", "B08선택",
                "B08점수", "B09이름", "B09선택", "B09점수", "B10이름", "B10선택", "B10점수", "B11이름", "B11선택", "B11점수", "B12이름", "B12선택", "B12점수", "B13이름",
                "B13선택", "B13점수", "B14이름", "B14선택", "B14점수", "B15이름", "B15선택", "B15점수", "P01이름", "P01선택", "P01점수", "P02이름", "P02선택", "P02점수	",
                "P03이름", "P03선택", "P03점수", "P04이름", "P04선택", "P04점수", "P05이름", "P05선택", "P05점수", "P06이름", "P06선택", "P06점수", "P07이름", "P07선택",
                "P07점수", "P08이름", "P08선택", "P08점수", "P09이름", "P09선택", "P09점수", "P10이름", "P10선택", "P10점수", "P11이름", "P11선택", "P11점수", "P12이름",
                "P12선택", "P12점수", "P13이름", "P13선택", "P13점수", "P14이름", "P14선택", "P14점수", "P15이름", "P15선택", "P15점수", "P16이름", "P16선택", "P16점수",
                "A01이름", "A01선택", "A01점수", "A02이름", "A02선택", "A02점수", "A03이름", "A03선택", "A03점수", "A04이름", "A04선택", "A04점수", "A05이름", "A05선택",
                "A05점수", "A06이름", "A06선택", "A06점수", "A07이름", "A07선택", "A07점수",
            ]
        ]);
        excelData.map((sheet, idx) => {
            XLSX.utils.sheet_add_aoa(excelSheet, [
                [
                    idx + 1,
                    sheet.spg.spgName,
                    sheet.panel.panelName,
                    sheet.ratingVoltage,
                    sheet.secondaryVoltage,
                    sheet.ratingCurrent,
                    sheet.cutoffCurrent,
                    sheet.ratedCapacity,
                    sheet.modelName,
                    sheet.serialNo,
                    sheet.manufacturer,
                    sheet.memo,
                    CUTIL.utc2time("YYYY-MM-DD", sheet.updatedTime),
                    // B,P,A 종합점수
                    sheet.basicAssess.totalScore,
                    sheet.premiumAssess.totalScore,
                    sheet.advancedAssess.totalScore,
                    // B - 이름,선택,점수
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 7)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 7)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 7)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 8)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 8)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 8)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 9)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 9)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 9)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 10)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 10)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 10)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 11)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 11)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 11)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 12)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 12)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 12)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 13)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 13)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 13)).map((s, idx) => (s.value))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 14)).map((s, idx) => (s.name))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 14)).map((s, idx) => (s.answer))),
                    ((sheet.basicAssess.assessment) && sheet.basicAssess.assessment.filter((f, idx) => (idx == 14)).map((s, idx) => (s.value))),
                    // p - 이름,선택,점수
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 7)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 7)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 7)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 8)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 8)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 8)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 9)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 9)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 9)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 10)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 10)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 10)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 11)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 11)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 11)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 12)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 12)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 12)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 13)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 13)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 13)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 14)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 14)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 14)).map((s, idx) => (s.value))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 15)).map((s, idx) => (s.name))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 15)).map((s, idx) => (s.answer))),
                    ((sheet.premiumAssess.assessment) && sheet.premiumAssess.assessment.filter((f, idx) => (idx == 15)).map((s, idx) => (s.value))),
                    // A - 이름,선택,점수
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.name))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.answer))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 0)).map((s, idx) => (s.value))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.name))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.answer))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 1)).map((s, idx) => (s.value))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.name))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.answer))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 2)).map((s, idx) => (s.value))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.name))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.answer))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 3)).map((s, idx) => (s.value))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.name))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.answer))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 4)).map((s, idx) => (s.value))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.name))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.answer))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 5)).map((s, idx) => (s.value))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.name))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.answer))),
                    ((sheet.advancedAssess.assessment) && sheet.advancedAssess.assessment.filter((f, idx) => (idx == 6)).map((s, idx) => (s.value))),
                ]
            ], { origin: -1 });
            excelSheet['!cols'] = [
                { width: 8, },
                { width: 10, },
                { width: 20, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 13, },
                { width: 30, },
                { width: 30, },
                { width: 30, },
                { width: 30, }, //메모
            ];
            return false;
        });
        // wb == workBook 약자
        const wb = { Sheets: { Sheet: excelSheet }, SheetNames: ["Sheet"] };
        const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const excelFile = new Blob([excelButter], { type: excelFileType });
        FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
        // XLSX.utils.book_append_sheet(book, excelSheet, "Sheet"); 
        // XLSX.writeFile(book, excelFileName + excelFileExtension);
    }
    // mobile List Popup
    function listPop(e, list) {
        if (isMobile) {
            // mobile 동작 여부 체크 // isMobile 이외의 mobile 여부 체크
            var schDiv = document.querySelector("#mcheck_searchinput");
            var isSchMobile = (schDiv.clientHeight <= 0) && (schDiv.clientWidth <= 0) ? true : false;
            if (!isSchMobile) {
                var popupVal = e.target.getAttribute("data-pop");
                if (CUTIL.isnull(popupVal))
                    e.target.setAttribute("data-pop", "pop-list-view");
                popupVal = e.target.getAttribute("data-ds-height");
                if (CUTIL.isnull(popupVal))
                    e.target.setAttribute("data-ds-height", "496");
            }
            setParentPopWin("pop-list-view", React.createElement(MobileListPop, { htmlHeader: React.createElement("h1", null,
                    list.modelName,
                    " \uC0C1\uC138\uC815\uBCF4"), list: list }));
            CUTIL.jsopen_m_Popup(e);
        }
    }
    // 운용관리 - 기기등록관리 Link
    function linkClick(e) {
        setRecoilUrlInfo(CONST.URL_ADMIN_ITEM);
        navigate(CONST.URL_ADMIN_ITEM);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "tab-1", className: "tabcontent current" },
            React.createElement("div", { className: "area__right w100p d-sm-block changeold " },
                React.createElement("h2", { className: "mb-0" }, t("LABEL.기기등록현황")),
                React.createElement("div", { className: "search" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("label", { htmlFor: "f1" }, t("LABEL.상세사업장")),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "select w186", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { id: "zone", className: "selected-value" }, t("FIELD.전체")),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null,
                                        React.createElement("li", { id: "zone_all", className: "option", onClick: (e) => selectSubZone("") }, t("FIELD.전체")),
                                        subZoneItem.map((sub, idx) => (React.createElement("li", { key: "zone_" + idx.toString(), className: "option", onClick: (e) => selectSubZone(sub.subZoneId) }, sub.subZoneName))))))),
                        React.createElement("li", null,
                            React.createElement("label", { htmlFor: "f2" }, t("LABEL.전기실")),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "select w186", onClick: (e) => (curSubZone) && CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { id: "room", className: "selected-value" }, t("FIELD.전체")),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null,
                                        React.createElement("li", { id: "room_all", className: "option", onClick: (e) => setCurRoom("") }, t("FIELD.전체")),
                                        (roomItem) && roomItem.map((room, idx) => (React.createElement("li", { key: "room_" + idx.toString(), className: "option", onClick: (e) => setCurRoom(room.roomId) }, room.roomName))))))),
                        React.createElement("li", null,
                            React.createElement("label", { htmlFor: "f3" }, t("FIELD.기기명")),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "select w186", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { id: "spg", className: "selected-value" }, t("FIELD.전체")),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null,
                                        React.createElement("li", { id: "spg_all", className: "option", onClick: (e) => setCurSpg("") }, t("FIELD.전체")),
                                        spgItem.map((spg, idx) => (React.createElement("li", { key: "zone_" + idx.toString(), className: "option", onClick: (e) => setCurSpg(spg.spgName) }, spg.spgName)))))))),
                    React.createElement("div", { className: "btn__wrap" },
                        React.createElement("button", { type: "button", className: "btn-search", onClick: (e) => searchDevice(e) },
                            React.createElement("span", null, t("LABEL.조회"))))),
                React.createElement("div", { className: "area__right_content  hcal-176" },
                    React.createElement("div", { className: "tbl__top d-lm-block mt-36" },
                        React.createElement("div", { className: "left" },
                            React.createElement("a", { className: "devicenum", onClick: (e) => linkClick(e) },
                                React.createElement("p", null, "Device"),
                                React.createElement("p", { className: "num" }, (countItem) ? countItem.totalCount : "-")),
                            React.createElement("ul", { className: "devicenum-detail" }, (countItem) && spgItem.map((spg, idx) => (React.createElement("li", { ref: mobileRef, key: "zone_" + idx.toString() },
                                spg.spgName,
                                React.createElement("span", null, (spg.spgName == "ACB") ?
                                    countItem.acbCount
                                    : (spg.spgName == "VCB") ?
                                        countItem.vcbCount
                                        : (spg.spgName == "배전반") ? countItem.switchboardCount
                                            : (spg.spgName == "MoldTR") ? countItem.moldTrCount
                                                : (spg.spgName == "유압식TR") ? countItem.oilTrCount
                                                    : (spg.spgName == "GIS") && countItem.gisCount))))),
                            React.createElement("div", { className: "filter js-open-s", "data-pop": "pop-filter", onClick: (e) => CUTIL.jsopen_m_Popup(e) },
                                React.createElement("p", { className: "title" },
                                    React.createElement("span", null, "Filter")))),
                        React.createElement("div", { className: "right" },
                            React.createElement("div", { className: "searcharea" },
                                React.createElement("div", { className: "searchinput", id: "mcheck_searchinput" },
                                    React.createElement("span", null, t("LABEL.검색")),
                                    React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { className: "selected-value" }, searchFieldList[0].sfDisp),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf), onClick: (e) => setSearchField(sf) }, sf.sfDisp))))),
                                    React.createElement("div", { className: "input__direct" },
                                        React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setSearchText(e.target.value) }),
                                        (searchText.length > 0) && React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setSearchText("") },
                                            React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30")))),
                                React.createElement("button", { type: "button", className: "btn-search js-open-m4", "data-pop": "pop-search-small", onClick: (e) => onClickSearch(e) },
                                    React.createElement("span", null, t("LABEL.조회"))),
                                React.createElement("button", { type: "button", className: "btn-basic ml-8 js-open", "data-pop": "pop-change", onClick: (e) => CUTIL.jsopen_Popup(e) },
                                    React.createElement("span", { "data-pop": "pop-change" }, t("LABEL.노후교체요청"))),
                                (userInfo.role == CONST.USERROLE_USER) ?
                                    React.createElement("button", { type: "button", className: "btn-basic down ml-8", disabled: true },
                                        React.createElement("span", null, "List Download"))
                                    :
                                        React.createElement("button", { type: "button", className: "btn-basic down ml-8", onClick: (e) => exeelList(zoneId) },
                                            React.createElement("span", null, "List Download"))))),
                    React.createElement("p", { className: "nodata__txt h345" }, t("MESSAGE.데이터를찾을수없습니다")),
                    React.createElement("div", { className: "tbl-list hcal-vh-415" },
                        React.createElement("table", { summary: "\uB4F1\uB85D \uC21C,\uAE30\uAE30 \uBA85,Panel \uBA85,\uBAA8\uB378 \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC815\uACA9\uC804\uC555,\uC815\uACA9\uC804\uB958,\uCC28\uB2E8\uC804\uB958,\uC815\uACA9\uC6A9\uB7C9,\uACC4\uD1B5\uC804\uC555,\uCCA8\uBD80\uD30C\uC77C,\uBA54\uBAA8 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C site\uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                            React.createElement("caption", null, "Basice-HCList"),
                            React.createElement("colgroup", null,
                                React.createElement("col", { style: {} })),
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", { scope: "col", className: "wmax-10" },
                                        React.createElement("input", { readOnly: true, type: "checkbox", id: "t_all", checked: checkItem.length === 0 ? false : checkItem.length === listItem.length ? true : false, onChange: (e) => checkedAll(e.target.checked) }),
                                        React.createElement("label", { htmlFor: "t_all" },
                                            React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "spgName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} txt-left `, onClick: (e) => onClickSort("spgName") },
                                        React.createElement("span", null, t("FIELD.기기명"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "panelName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left`, onClick: (e) => onClickSort("panelName") },
                                        React.createElement("span", null, t("FIELD.Panel명"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "itemName") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-sm-none`, onClick: (e) => onClickSort("itemName") },
                                        React.createElement("span", null, t("FIELD.모델명"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "serialNo") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-lm-none d-sm-none`, onClick: (e) => onClickSort("serialNo") },
                                        React.createElement("span", null, t("FIELD.시리얼번호"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "ratingVoltage") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-lm-none d-sm-none`, onClick: (e) => onClickSort("ratingVoltage") },
                                        React.createElement("span", null, t("FIELD.정격전압"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "secondaryVoltage") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-lm-none d-sm-none`, onClick: (e) => onClickSort("secondaryVoltage") },
                                        React.createElement("span", null, t("FIELD.2차전압"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "ratingCurrent") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-lm-none d-sm-none`, onClick: (e) => onClickSort("ratingCurrent") },
                                        React.createElement("span", null, t("FIELD.정격전류"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "cutoffCurrent") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-lm-none d-sm-none`, onClick: (e) => onClickSort("cutoffCurrent") },
                                        React.createElement("span", null, t("FIELD.차단전류"))),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "ratedCapacity") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-lm-none d-sm-none`, onClick: (e) => onClickSort("ratedCapacity") },
                                        React.createElement("span", null, t("FIELD.정격용량"))),
                                    React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                        React.createElement("span", null, "Basic")),
                                    React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                        React.createElement("span", null, "Premium")),
                                    React.createElement("th", { scope: "col", className: "txt-left d-sm-none" },
                                        React.createElement("span", null, "Advanced")),
                                    React.createElement("th", { scope: "col", className: `sort ${(sortData.sortField === "updatedTime") ? (sortData.sort === "ASC") ? "asc" : "desc" : "asc"} asc txt-left d-sm-none`, onClick: (e) => onClickSort("updatedTime") },
                                        React.createElement("span", null, t("FIELD.점검일자"))))),
                            React.createElement("tbody", null, (listItem) && listItem.map((list, idx) => (React.createElement("tr", { key: "status_" + idx.toString(), className: "js-open-m2", "data-pop": "pop-list-view" },
                                React.createElement("td", { className: "wmax-10" },
                                    React.createElement("input", { type: "checkbox", id: "t_" + idx.toString(), checked: checkItem.includes(list) ? true : false, onChange: (e) => checkedList(e.target.checked, list) }),
                                    React.createElement("label", { htmlFor: "t_" + idx.toString() },
                                        React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                                React.createElement("td", { className: "txt-left js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.spg.spgName) ? list.spg.spgName : "-"),
                                React.createElement("td", { className: "txt-left js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) },
                                    React.createElement("p", { className: "ellipsis" }, (list.panel.panelName) ? list.panel.panelName : "-")),
                                React.createElement("td", { className: "txt-left d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) },
                                    React.createElement("p", { className: "ellipsis" }, (list.modelName) ? list.modelName : "-")),
                                React.createElement("td", { className: "txt-left d-lm-none d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) },
                                    React.createElement("p", { className: "ellipsis" }, (list.serialNo) ? list.serialNo : "-")),
                                React.createElement("td", { className: "txt-left d-lm-none d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.ratingVoltage) ? list.ratingVoltage : "-"),
                                React.createElement("td", { className: "txt-left d-lm-none d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.secondaryVoltage) ? list.secondaryVoltage : "-"),
                                React.createElement("td", { className: "txt-left d-lm-none d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.ratingCurrent) ? list.ratingCurrent : "-"),
                                React.createElement("td", { className: "txt-left d-lm-none d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.cutoffCurrent) ? list.cutoffCurrent : "-"),
                                React.createElement("td", { className: "txt-left d-lm-none d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.ratedCapacity) ? list.ratedCapacity : "-"),
                                React.createElement("td", { className: "txt-left d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.basicScore.totalScore) ? list.basicScore.totalScore : "-"),
                                React.createElement("td", { className: "txt-left d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.premiumScore.totalScore) ? list.premiumScore.totalScore : "-"),
                                React.createElement("td", { className: "txt-left d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.advancedScore.totalScore) ? list.advancedScore.totalScore : "-"),
                                React.createElement("td", { className: "txt-left d-sm-none js-open-m2", "data-pop": "pop-list-view", onClick: (e) => listPop(e, list) }, (list.updatedTime) ? CUTIL.utc2time("YYYY-MM-DD", list.updatedTime) : "-")))))))),
                (pageInfo) && React.createElement(EhpPagination, { componentName: "WorkOrderInspection", pageInfo: pageInfo, handleFunc: handleCurPage })))));
}
export default DeciveStatusView;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
function MobileFilterPopup(props) {
    const t = useTrans();
    //props
    const subZoneItem = props.subZoneItem;
    const roomItem = props.roomItem;
    const spgItem = props.spgItem;
    const curSubZone = props.curSubZone;
    const setCurRoom = props.setCurRoom;
    const setCurSpg = props.setCurSpg;
    const selectSubZone = props.selectSubZone;
    const searchDevice = props.searchDevice;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body minhcal-210 maxhcal-210 scrollH" },
            React.createElement("ul", { className: "form__input mt-0" },
                React.createElement("li", { className: "mt-0" },
                    React.createElement("label", { htmlFor: "company" }, t("LABEL.상세사업장")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "mzone", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, t("FIELD.전체")),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", null,
                                React.createElement("li", { id: "mzone_all", className: "option", onClick: (e) => selectSubZone("") }, t("FIELD.전체")),
                                subZoneItem.map((sub, idx) => (React.createElement("li", { key: "zone_" + idx.toString(), className: "option", onClick: (e) => selectSubZone(sub.subZoneId) }, sub.subZoneName))))))),
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "site" }, t("LABEL.전기실")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "mroom", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, t("FIELD.전체")),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", null,
                                React.createElement("li", { id: "mroom_all", className: "option", onClick: (e) => (curSubZone) && setCurRoom("") }, t("FIELD.전체")),
                                (roomItem) && roomItem.map((room, idx) => (React.createElement("li", { key: "room_" + idx.toString(), className: "option", onClick: (e) => setCurRoom(room.roomId) }, room.roomName))))))),
                React.createElement("li", null,
                    React.createElement("label", { htmlFor: "dd" }, t("LABEL.기기명")),
                    React.createElement("div", { className: "input__area" },
                        React.createElement("div", { id: "mspg", className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                            React.createElement("div", { className: "selected" },
                                React.createElement("div", { className: "selected-value" }, t("FIELD.전체")),
                                React.createElement("div", { className: "arrow" })),
                            React.createElement("ul", null,
                                React.createElement("li", { id: "mspg_all", className: "option", onClick: (e) => setCurSpg("") }, t("FIELD.전체")),
                                spgItem.map((spg, idx) => (React.createElement("li", { key: "zone_" + idx.toString(), className: "option", onClick: (e) => setCurSpg(spg.spgName) }, spg.spgName))))))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close" },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", className: "js-close", onClick: (e) => searchDevice(e) },
                React.createElement("span", null, t("LABEL.적용"))))));
}
function MobilePopupSearch(props) {
    //trans
    const t = useTrans();
    //props
    const searchFieldList = props.searchFieldList;
    const setParentSearchField = props.setSearchField;
    const searchText = props.searchText;
    const setParentSearchText = props.setSearchText;
    const goSearch = props.goSearch;
    //const [searchText, setSearchText] = useState("");
    // option 선택 시  값 변경 액션
    function selectOptionSearchField(optionElement) {
        const selectBox = optionElement.closest(".select");
        const selectedElement = selectBox.querySelector(".selected-value ");
        selectedElement.textContent = optionElement.textContent;
        var optionData = optionElement.getAttribute("data-value");
        selectedElement.setAttribute("data-value", optionData);
        //
        var sf = JSON.parse(optionData);
        if (sf.sfVal.length <= 0)
            setParentSearchText("");
        //if ( sf.sfVal.length <= 0 ) setSearchText("");
        setParentSearchField(sf);
        //
    }
    function onClickCancel(e) {
        CUTIL.jsclose_Popup("pop-search-small");
    }
    function handleGoSearch(e) {
        goSearch(e);
        CUTIL.jsclose_Popup("pop-search-small");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "form__input mb-0" },
                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, selectOptionSearchField) },
                    React.createElement("div", { className: "selected" },
                        React.createElement("div", { className: "selected-value" }, searchFieldList[0].sfDisp),
                        React.createElement("div", { className: "arrow" })),
                    React.createElement("ul", null, searchFieldList.map((sf, idx) => (React.createElement("li", { key: `sf_${idx.toString()}`, className: "option", "data-value": JSON.stringify(sf) }, sf.sfDisp))))),
                React.createElement("div", { className: "input__direct" },
                    React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.검색어")]), value: searchText, onChange: (e) => setParentSearchText(e.target.value) }),
                    (searchText.length > 0) && React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => setParentSearchText("") },
                        React.createElement("span", { className: "hide" }, "\uC785\uB825 \uCC3D \uB2EB\uAE30"))))),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => onClickCancel(e) },
                React.createElement("span", null, t("LABEL.취소"))),
            React.createElement("button", { type: "button", onClick: (e) => handleGoSearch(e) },
                React.createElement("span", null, t("LABEL.적용"))))));
}
function ChanagePop(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = props.setRecoilIsLoadingBox;
    //props
    const checkItem = props.checkItem;
    const setCheckItem = props.setCheckItem;
    const [changeSuccess, setChangeSuccess] = useState([]);
    const [changeFail, setChangeFail] = useState([]);
    //노후 교체 요청  API
    function changeDone(checkItem) {
        return __awaiter(this, void 0, void 0, function* () {
            setRecoilIsLoadingBox(true);
            var btnCommentClose = document.getElementById("pop-change");
            if (!CUTIL.isnull(btnCommentClose))
                btnCommentClose.classList.add("hidden");
            var itemId = [];
            for (let i = 0; i < checkItem.length; i++) {
                itemId.push(checkItem[i].itemId);
            }
            let data = [];
            var success = [];
            var fail = [];
            for (let j = 0; j < checkItem.length; j++) {
                data = yield HttpUtil.PromiseHttp({
                    "httpMethod": "POST",
                    "appPath": `/api/v2/product/company/zone/subzone/room/panel/item/deviceconsult`,
                    "appQuery": {
                        "itemId": itemId[j]
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        success.push(data.body);
                        // alert("담당자 배정 접수가 되었습니다.");
                    }
                    else {
                        // alert(data.data.errorList[0].msg);
                        fail.push(data.errorList);
                    }
                }
            }
            if (data) {
                setChangeSuccess(success);
                // alert("담당자 배정 접수가 되었습니다.");
                // alert(data.data.errorList[0].msg);
                setChangeFail(fail);
                var btnCommentClose = document.getElementById("pop-change");
                var body = document.body;
                var dimm = body.querySelector(".dimm");
                if (!CUTIL.isnull(btnCommentClose))
                    btnCommentClose.classList.remove("hidden");
                if (!CUTIL.isnull(body))
                    body.setAttribute("style", "overflow-y: hidden;");
                if (!CUTIL.isnull(dimm))
                    dimm.setAttribute("style", "z-index: 30; display: block;");
                setRecoilIsLoadingBox(false);
            }
        });
    }
    //팝업 닫기 , 요청 완료 후 확인 버튼 
    function PopCloses(id) {
        var btnCommentClose = document.getElementById(id);
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "itmeTxt: none; z-index: 11; ");
        setCheckItem([]);
        setChangeFail([]);
        setChangeSuccess([]);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, (changeFail.length > 0 || changeSuccess.length > 0) ?
                " 노후교체 요청이 완료되었습니다."
                : (checkItem.length > 0) ?
                    "해당 기기를 노후교체 요청하시겠습니까?"
                    : "기기를 먼저 선택해주세요."),
            (changeFail.length > 0 || changeSuccess.length > 0) &&
                React.createElement("p", null,
                    React.createElement("span", null,
                        " - ",
                        t("LABEL.성공"),
                        " : ",
                        changeSuccess.length,
                        " ",
                        t("LABEL.건")),
                    React.createElement("br", null),
                    React.createElement("span", null,
                        " - ",
                        t("LABEL.실패"),
                        " : ",
                        changeFail.length,
                        " ",
                        t("LABEL.T1이미신청한기기", [t("LABEL.건")])))),
        React.createElement("div", { className: "popup__footer" },
            (checkItem.length > 0) && (changeFail.length <= 0 && changeSuccess.length <= 0) &&
                React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => PopCloses("pop-change") },
                    React.createElement("span", null, t("LABEL.취소"))),
            (checkItem.length <= 0) || (changeFail.length > 0 || changeSuccess.length > 0) ?
                React.createElement("button", { type: "button", className: "js-close", onClick: (e) => PopCloses("pop-change") },
                    React.createElement("span", null, t("LABEL.확인")))
                :
                    React.createElement("button", { type: "button", onClick: (e) => changeDone(checkItem) },
                        React.createElement("span", null, t("LABEL.확인"))))));
}
function PopupReportView(props) {
    //trans
    const t = useTrans();
    //porps
    const item = props.itemDetail;
    const reportInfo = props.reportInfo;
    //const reportList = (reportInfo != null ) ? reportInfo.IF_RES_DATA : null;
    const [reportList, setReportList] = useState(null);
    const [checkAll, setCheckAll] = useState(false);
    const [checkReports, setCheckReports] = useState([]);
    useEffect(() => {
        //if ( reportInfo == null ) {
        //}
        setReportList((reportInfo != null) ? reportInfo.IF_RES_DATA : null);
        setCheckAll(false);
        //setCheckReports([]);
    }, [reportInfo]);
    function handleAllCheck(e) {
        var isChecked = e.target.checked;
        setCheckAll(isChecked);
        setReportList(reportList.map((report) => (Object.assign(Object.assign({}, report), { "checked": isChecked }))));
    }
    function handleCheckReports(e, check) {
        const isChecked = e.target.checked;
        const tmpReports = reportList.map((report) => (report.REPORT_NO === check.REPORT_NO) && Object.assign(Object.assign({}, report), { "checked": isChecked }));
        const tmpChecks = tmpReports.filter((report) => (report.checked));
        if (tmpChecks.length === tmpReports.length) {
            setCheckAll(true);
        }
        else {
            setCheckAll(false);
        }
        setReportList(tmpReports);
    }
    function pdfDownloadAll(e) {
        reportList.filter((report) => report.checked).map((report) => {
            clog("IN pdfDownloadAll : " + JSON.stringify(report));
        });
        let zips = new JSZip();
        let zipCnt = 0;
        //const zipFileName = `${item.itemName}_검사성적서.zip` 최효일PM님 지시로 문구 변경 by jhpark-20221219
        const zipFileName = `TestReport.zip`;
        reportList.filter((report) => report.checked).map((report) => {
            const sPos = (report.PDF_LINK.lastIndexOf('/') < 0) ? 0 : report.PDF_LINK.lastIndexOf('/');
            const ePos = (report.PDF_LINK.lastIndexOf('?') < 0) ? report.PDF_LINK.length : report.PDF_LINK.lastIndexOf('?');
            var fileName = report.PDF_LINK.substring(sPos + 1, ePos);
            axios({
                method: "GET",
                url: report.PDF_LINK,
                responseType: "blob",
            }).then((resp) => {
                zips.file(fileName, resp.data);
                zipCnt++;
                return zipCnt;
            }).then((zipCnt) => {
                if (zipCnt === reportList.length) {
                    //FILEUTILS.saveToFile_Chrome(fileName, response.data);
                    zips.generateAsync({ type: "blob" }).then(function (blob) {
                        FILEUTIL.saveToFile_Chrome(zipFileName, blob);
                    });
                }
            });
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "tbl-list type5" },
                React.createElement("table", { summary: "\uC120\uD0DD,\uD30C\uC77C \uBA85, \uC0DD\uC131\uC77C, \uCCA8\uBD80 \uD30C\uC77C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC2DC\uD5D8\uC131\uC801\uC11C \uB2E4\uC6B4\uB85C\uB4DC \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                    React.createElement("caption", null, "\uC2DC\uD5D8\uC131\uC801\uC11C \uB2E4\uC6B4\uB85C\uB4DC \uBAA9\uB85D"),
                    React.createElement("colgroup", null,
                        React.createElement("col", { style: { "width": "20px" } }),
                        React.createElement("col", { style: { "width": "auto" } }),
                        React.createElement("col", { style: { "width": "17%" } }),
                        React.createElement("col", { style: { "width": "15%" } })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { scope: "col", className: "w20" }),
                            React.createElement("th", { scope: "col" }, t("FIELD.파일명")),
                            React.createElement("th", { scope: "col" }, t("FIELD.생성일")),
                            React.createElement("th", { scope: "col", className: "txt-center" }, t("FIELD.첨부파일")))),
                    React.createElement("tbody", null, (reportList == null)
                        ? React.createElement("tr", { key: "report_null" },
                            React.createElement("td", { className: "d-sm-none w20" },
                                React.createElement("p", { className: "icon-no ml-m10" },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uC5C6\uC74C"))),
                            React.createElement("td", { className: "d-sm-none" }, t("MESSAGE.등록된성적서가없습니다")),
                            React.createElement("td", { className: "d-sm-none" }, "-"),
                            React.createElement("td", { className: "btn__tdarea" },
                                React.createElement("p", { className: "icon-no gray" },
                                    React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uC5C6\uC74C"))))
                        : (reportList) && reportList.map((report, idx) => (React.createElement("tr", { key: "report_" + idx },
                            React.createElement("td", { scope: "col", className: "w20" }),
                            React.createElement("td", null,
                                React.createElement("p", { className: "ellipsis" }, report.PDF_LINK.substring(report.PDF_LINK.lastIndexOf('/') + 1, report.PDF_LINK.lastIndexOf('.')))),
                            React.createElement("td", null, report.CREATION_DATE.substring(0, 4) + "-" + report.CREATION_DATE.substring(4, 6) + "-" + report.CREATION_DATE.substring(6, 8)),
                            React.createElement("td", null, (report.PDF_LINK == null)
                                ? React.createElement("button", { type: "button", className: "btn btn-file", disabled: true },
                                    React.createElement("span", { className: "hide" }, "\uCCA8\uBD80 \uD30C\uC77C"))
                                : React.createElement("a", { href: report.PDF_LINK, target: "_blank", rel: 'noreferrer' },
                                    React.createElement("button", { type: "button", className: "btn btn-file" },
                                        React.createElement("span", { className: "hide" }, "\uCCA8\uBD80 \uD30C\uC77C"))))))))))),
        React.createElement("div", { className: "popup__footer brd-0 mb-10" },
            React.createElement("button", { type: "button", className: "bg-gray js-close" },
                React.createElement("span", null, "Cancel")))));
}
function MobileListPop(props) {
    //trans
    const t = useTrans();
    //
    const list = (props.list === null) ? null : props.list;
    function listDone(e) {
        var btnCommentClose = document.getElementById("pop-list-view");
        var body = document.body;
        var dimm = body.querySelector(".dimm");
        if (!CUTIL.isnull(btnCommentClose))
            btnCommentClose.classList.add("hidden");
        if (!CUTIL.isnull(body))
            body.setAttribute("style", "overflow-y: auto;");
        if (!CUTIL.isnull(dimm))
            dimm.setAttribute("style", "display: none; z-index: 11;");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("div", { className: "area__right_content workplace__info" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" },
                        t("LABEL.T1상세정보", [t("LABEL.기기등록현황")]),
                        " "),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.기기명")),
                            React.createElement("p", { className: "txt" }, (list.spg.spgName) ? list.spg.spgName : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.Panel명")),
                            React.createElement("p", { className: "txt" }, (list.panel.panelName) ? list.panel.panelName : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.모델명")),
                            React.createElement("p", { className: "txt" }, (list.modelName) ? list.modelName : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.시리얼번호")),
                            React.createElement("p", { className: "txt" }, (list.serialNo) ? list.serialNo : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.정격전압")),
                            React.createElement("p", { className: "txt" }, (list.ratingVoltage) ? list.ratingVoltage : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.2차전압")),
                            React.createElement("p", { className: "txt" }, (list.secondaryVoltage) ? list.secondaryVoltage : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.정격전류")),
                            React.createElement("p", { className: "txt" }, (list.ratingCurrent) ? list.ratingCurrent : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.차단전류")),
                            React.createElement("p", { className: "txt" }, (list.cutoffCurrent) ? list.cutoffCurrent : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.정격용량")),
                            React.createElement("p", { className: "txt" }, (list.ratedCapacity) ? list.ratedCapacity : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "Basic"),
                            React.createElement("p", { className: "txt" }, (list.basicScore.totalScore) ? list.basicScore.totalScore : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "Premium"),
                            React.createElement("p", { className: "txt" }, (list.premiumScore.totalScore) ? list.premiumScore.totalScore : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "Advanced"),
                            React.createElement("p", { className: "txt" }, (list.advancedScore.totalScore) ? list.advancedScore.totalScore : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, t("FIELD.점검일자")),
                            React.createElement("p", { className: "txt" }, (list.updatedTime) ? CUTIL.utc2time("YYYY-MM-DD", list.updatedTime) : "-")))),
                React.createElement("div", { className: "btn__wrap" },
                    React.createElement("button", { type: "button", className: "js-close", onClick: (e) => listDone(e) },
                        React.createElement("span", null, t("LABEL.확인"))))))));
}
